
export default {
    name: 'InvalidFeedback',
    props: {
        error: {
            type: String,
            default: '',
        },
    },
}
